module.exports = __webpack_public_path__ + "img/card-image-4.83c3252e.jpg";